import { Moment } from 'moment'
import { TrackingUserGroup } from './Tracking'

export class DataFilters {
  template: number
  templateName: string
  initDate: string
  endDate: string
  group: number
  groupName: string
  groupObject: TrackingUserGroup

  getValidParams () {
    const params = {} as any
    if (this.template) params['template'] = this.template.toString()
    if (this.initDate) params['initDate'] = this.initDate
    if (this.endDate) params['endDate'] = this.endDate
    if (this.group) params['group'] = this.group.toString()
    return params
  }
}

export class KpiItem {
  name: string
  value: number
  prefix: string
  suffix: string
  icon: string
  color: string

  static getInstance (): KpiItem {
    return new KpiItem()
  }

  withName (name: string): KpiItem {
    this.name = name
    return this
  }

  withValue (value: number): KpiItem {
    this.value = value
    return this
  }

  withPrefix (prefix: string): KpiItem {
    this.prefix = prefix
    return this
  }

  withSuffix (suffix: string): KpiItem {
    this.suffix = suffix
    return this
  }

  withIcon (icon: string): KpiItem {
    this.icon = icon
    return this
  }

  withColor (color: string): KpiItem {
    this.color = color
    return this
  }
}

export class DashboardReport {
  id: string
  name: string
}

export enum FiltersDateFormats {
  QUERY_STRING = 'DDMMYYYY',
  FROM_QUERY_STRING = 'YYYY-MM-DD'
}

export class KpiUserProductivity {
  user: string
  // eslint-disable-next-line
  worked_hours: string
  // eslint-disable-next-line
  worked_amount: number
  _workedHoursNumber: number
}

export class KpiUserProductivityDate {
  date: string
  users: KpiUserProductivity[]
  _dateFormatted: Moment
}

export class CapacityProductivityResponse {
  total: number
  dates: KpiUserProductivityDate[]
}

export class KpisProductivity {
  date: string
  groupId: number
  groupName: string
  totalUsers = 0
  workedTasksCount = 0
  workedHoursCount = 0
  usersWithAtLeastOneTask = 0
  precentageUsersWhoWorked = 0
  averageWorkedTasks = 0
  avegareWorkedHours = 0
}

export class KpisUserProductivity {
  userName: string
  workedDays = 0
  workedTasksCount = 0
  workedHoursCount = 0
  averageWorkedTasks = 0
  avegareWorkedHours = 0
}

export class KpisUserStatusManagement {
  user: string
  status: string
  managed: number
  // eslint-disable-next-line
  managed_today: number
  // eslint-disable-next-line
  pending_management: number
  isWorkingUser: boolean
  isNotWorkingUser: boolean
  isNotAssignedUser: boolean
}

export class KpisStatusManagementData {
  unassigned: number
  users: KpisUserStatusManagement[]
}

export class KpisStatusManagement {
  unassignedTasks: number
  sumManagedTasks: number
  sumManagedTasksToday: number
  sumPendingManagement: number
  sumActiveUsers: number
  sumWorkingUsers: number
  sumNotWorkingUsers: number
  sumNotAssignedUsers: number
  totalTasks: number
  totalUsers: number
}

export class KpisConnectionReportDataUserIndicator {
  status: number = 0
  task: number = 0
  totalUsers: number = 0
}

export class KpisConnectionReportDataUsers {
  user: string
  group: string
  0: KpisConnectionReportDataUserIndicator
  1: KpisConnectionReportDataUserIndicator
  2: KpisConnectionReportDataUserIndicator
  3: KpisConnectionReportDataUserIndicator
  4: KpisConnectionReportDataUserIndicator
  5: KpisConnectionReportDataUserIndicator
  6: KpisConnectionReportDataUserIndicator
  7: KpisConnectionReportDataUserIndicator
  8: KpisConnectionReportDataUserIndicator
  9: KpisConnectionReportDataUserIndicator
  10: KpisConnectionReportDataUserIndicator
  11: KpisConnectionReportDataUserIndicator
  12: KpisConnectionReportDataUserIndicator
  13: KpisConnectionReportDataUserIndicator
  14: KpisConnectionReportDataUserIndicator
  15: KpisConnectionReportDataUserIndicator
  16: KpisConnectionReportDataUserIndicator
  17: KpisConnectionReportDataUserIndicator
  18: KpisConnectionReportDataUserIndicator
  19: KpisConnectionReportDataUserIndicator
  20: KpisConnectionReportDataUserIndicator
  21: KpisConnectionReportDataUserIndicator
  22: KpisConnectionReportDataUserIndicator
  23: KpisConnectionReportDataUserIndicator
}

export class KpisConnectionReportData {
  groupId: string
  groupName: string
  totalUsers: number
  users: KpisConnectionReportDataUsers[]
}

export class KpisGroupIndicatorsByTime {
  groupName: string
  totalUsers: number
  // averageConnecton: number
  0 = new KpisGroupIndicatorsBySpecificTime()
  1 = new KpisGroupIndicatorsBySpecificTime()
  2 = new KpisGroupIndicatorsBySpecificTime()
  3 = new KpisGroupIndicatorsBySpecificTime()
  4 = new KpisGroupIndicatorsBySpecificTime()
  5 = new KpisGroupIndicatorsBySpecificTime()
  6 = new KpisGroupIndicatorsBySpecificTime()
  7 = new KpisGroupIndicatorsBySpecificTime()
  8 = new KpisGroupIndicatorsBySpecificTime()
  9 = new KpisGroupIndicatorsBySpecificTime()
  10 = new KpisGroupIndicatorsBySpecificTime()
  11 = new KpisGroupIndicatorsBySpecificTime()
  12 = new KpisGroupIndicatorsBySpecificTime()
  13 = new KpisGroupIndicatorsBySpecificTime()
  14 = new KpisGroupIndicatorsBySpecificTime()
  15 = new KpisGroupIndicatorsBySpecificTime()
  16 = new KpisGroupIndicatorsBySpecificTime()
  17 = new KpisGroupIndicatorsBySpecificTime()
  18 = new KpisGroupIndicatorsBySpecificTime()
  19 = new KpisGroupIndicatorsBySpecificTime()
  20 = new KpisGroupIndicatorsBySpecificTime()
  21 = new KpisGroupIndicatorsBySpecificTime()
  22 = new KpisGroupIndicatorsBySpecificTime()
  23 = new KpisGroupIndicatorsBySpecificTime()
}

export class KpisGroupIndicatorsBySpecificTime {
  numberUsersAtTime = 0
  numberTasks = 0
  averageConnectedUsers = 0
}
